import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, ChevronDown, Plus, Filter } from 'lucide-react';
const HubSpot: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all-lists');
  // Mock data based on alerts
  const alertsData = [{
    id: 1,
    name: 'Potential Analytics Upsell (High Manual Reporting)',
    description: 'Flags accounts doing heavy manual analysis, suggesting they\'re ready for the "Advanced Analytics" package.',
    category: 'Upsell & Expansion',
    matches: 5,
    lastRun: '2 hours ago',
    status: 'Active',
    size: 5,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 19, 2025 12:39 AM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 2,
    name: 'Potential Brand Portal Upsell (Brand Filter Usage)',
    description: 'Identifies accounts providing reports to external partners, signaling a need for "Brand Portals".',
    category: 'Upsell & Expansion',
    matches: 8,
    lastRun: '1 day ago',
    status: 'Active',
    size: 8,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 3,
    name: 'User Overage - License Limit Exceeded',
    description: 'A direct expansion signal that an account has added more users than their subscription allows and needs to be billed for the overage.',
    category: 'Upsell & Expansion',
    matches: 3,
    lastRun: '12 hours ago',
    status: 'Active',
    size: 3,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 4,
    name: 'Manufacturer Not Using Assemblies',
    description: 'A critical alert for a key persona not using a sticky feature, indicating a major onboarding failure or churn risk.',
    category: 'Churn & Onboarding Risk',
    matches: 7,
    lastRun: '6 hours ago',
    status: 'Active',
    size: 7,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 5,
    name: 'High-Value Account is Underusing the Platform',
    description: 'Flags high-MRR customers who are dangerously disengaged from the product, requiring immediate proactive outreach to prevent churn.',
    category: 'Churn & Onboarding Risk',
    matches: 2,
    lastRun: '1 day ago',
    status: 'Active',
    size: 2,
    type: 'Inactive',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 6,
    name: 'Distributor with Unusually Low Sales Volume',
    description: 'Identifies a distributor whose sales volume is below the expected baseline for their persona, suggesting a potential business or adoption problem.',
    category: 'Churn & Onboarding Risk',
    matches: 4,
    lastRun: '8 hours ago',
    status: 'Active',
    size: 4,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 7,
    name: 'Small Customer Using E-commerce Menu Exclusively',
    description: 'A strategic alert for the product team that identifies customers who are essentially buying the entire platform for one feature, signaling a potential to modularize that feature into a new product.',
    category: 'Product & Strategy',
    matches: 6,
    lastRun: '3 hours ago',
    status: 'Active',
    size: 6,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }];
  const handleListClick = (id: number) => {
    navigate(`/hubspot/lists/${id}`);
  };
  return <div className="bg-white min-h-screen" data-id="element-950">
      {/* HubSpot-like header */}
      <div className="border-b border-gray-200 bg-[#33475b] text-white py-2 px-4 flex items-center justify-between" data-id="element-951">
        <div className="flex items-center" data-id="element-952">
          <div className="mr-4" data-id="element-953">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" data-id="element-954">
              <path d="M22.447 10.105h-6.225v-1.293h6.225v1.293zm-6.225 4.278h6.225v-1.293h-6.225v1.293zm0 4.278h6.225v-1.293h-6.225v1.293zm-7.437-2.985a3.026 3.026 0 0 1-3.022-3.022 3.026 3.026 0 0 1 3.022-3.022 3.026 3.026 0 0 1 3.022 3.022 3.026 3.026 0 0 1-3.022 3.022m0-8.557a5.542 5.542 0 0 0-5.535 5.535 5.542 5.542 0 0 0 5.535 5.535 5.542 5.542 0 0 0 5.535-5.535 5.542 5.542 0 0 0-5.535-5.535m-5.535-3.022h4.242V1.855H3.25v4.242h4.242z" data-id="element-955" />
            </svg>
          </div>
          <div className="relative" data-id="element-956">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-957" />
            <input type="text" placeholder="Search HubSpot" className="bg-[#496b8a] text-white placeholder-gray-300 rounded pl-10 pr-4 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-958" />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 text-xs" data-id="element-959">
              Ctrl K
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-4" data-id="element-960">
          <button className="text-white" data-id="element-961">
            <span className="sr-only" data-id="element-962">Notifications</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-963">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" data-id="element-964"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0" data-id="element-965"></path>
            </svg>
          </button>
          <div className="flex items-center" data-id="element-966">
            <span className="text-sm font-medium mr-2" data-id="element-967">Our Company</span>
            <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center" data-id="element-968">
              DA
            </div>
          </div>
        </div>
      </div>
      {/* Lists header */}
      <div className="p-6" data-id="element-969">
        <div className="flex justify-between items-center mb-4" data-id="element-970">
          <div data-id="element-971">
            <h1 className="text-2xl font-medium text-gray-800" data-id="element-972">Lists</h1>
            <p className="text-sm text-gray-500" data-id="element-973">{alertsData.length} lists</p>
          </div>
          <div className="flex space-x-2" data-id="element-974">
            <button className="text-sm text-blue-600 hover:text-blue-800 flex items-center" data-id="element-975">
              What's new? <span className="ml-1" data-id="element-976">?</span>
            </button>
            <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-977">
              Admin settings <ChevronDown size={14} className="ml-1" data-id="element-978" />
            </button>
            <button className="border border-gray-300 rounded px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50" data-id="element-979">
              Import
            </button>
            <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-980">
              Quick create <ChevronDown size={14} className="ml-1" data-id="element-981" />
            </button>
            <button className="bg-orange-500 hover:bg-orange-600 text-white rounded px-3 py-1.5 text-sm" data-id="element-982">
              Create list
            </button>
          </div>
        </div>
        {/* Tabs */}
        <div className="border-b border-gray-200 mb-4" data-id="element-983">
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'all-lists' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('all-lists')} data-id="element-984">
            All lists
          </button>
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'unused-lists' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('unused-lists')} data-id="element-985">
            Unused lists
          </button>
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'recently-deleted' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('recently-deleted')} data-id="element-986">
            Recently deleted
          </button>
        </div>
        {/* Filters */}
        <div className="flex items-center space-x-3 mb-4" data-id="element-987">
          <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-988">
            All creators <ChevronDown size={14} className="ml-1" data-id="element-989" />
          </button>
          <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-990">
            All types <ChevronDown size={14} className="ml-1" data-id="element-991" />
          </button>
          <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-992">
            All objects <ChevronDown size={14} className="ml-1" data-id="element-993" />
          </button>
          <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-994">
            Used in <ChevronDown size={14} className="ml-1" data-id="element-995" />
          </button>
          <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-996">
            <Plus size={14} className="mr-1" data-id="element-997" /> More
          </button>
          <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-998">
            <Filter size={14} className="mr-1" data-id="element-999" /> Advanced filters
          </button>
        </div>
        {/* Search */}
        <div className="relative mb-4" data-id="element-1000">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-1001" />
          <input type="text" placeholder="Search lists" className="border border-gray-300 rounded pl-10 pr-4 py-2 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1002" />
        </div>
        {/* Table */}
        <div className="border border-gray-200 rounded-md overflow-hidden" data-id="element-1003">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1004">
            <thead className="bg-gray-50" data-id="element-1005">
              <tr data-id="element-1006">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1007">
                  <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-1008" />
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1009">
                  Name <span className="ml-1" data-id="element-1010">ⓘ</span>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1011">
                  List Size
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1012">
                  Type <span className="ml-1" data-id="element-1013">ⓘ</span>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1014">
                  Object <span className="ml-1" data-id="element-1015">ⓘ</span>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1016">
                  Last Updated (PDT) <span className="ml-1" data-id="element-1017">ⓘ</span>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1018">
                  Creator <span className="ml-1" data-id="element-1019">ⓘ</span>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1020">
                  Folder <span className="ml-1" data-id="element-1021">ⓘ</span>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1022">
                  Used In (Count) <span className="ml-1" data-id="element-1023">ⓘ</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1024">
              {alertsData.map(alert => <tr key={alert.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleListClick(alert.id)} data-id="element-1025">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1026">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-1027" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1028">
                    <div className="text-sm text-blue-600 hover:underline" data-id="element-1029">
                      {alert.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1030">
                    <div className="text-sm text-gray-900" data-id="element-1031">{alert.size}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1032">
                    <div className="text-sm text-gray-900 flex items-center" data-id="element-1033">
                      <span className={`mr-2 w-2 h-2 rounded-full ${alert.type === 'Active' ? 'bg-green-500' : 'bg-gray-500'}`} data-id="element-1034"></span>
                      {alert.type}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1035">
                    <div className="text-sm text-gray-900" data-id="element-1036">{alert.object}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1037">
                    <div className="text-sm text-gray-900" data-id="element-1038">
                      {alert.lastUpdated}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-1039">
                      by {alert.creator}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1040">
                    <div className="text-sm text-gray-900" data-id="element-1041">{alert.creator}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1042">
                    <div className="text-sm text-gray-900" data-id="element-1043">{alert.folder}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1044">
                    <div className="text-sm text-gray-900" data-id="element-1045">
                      {alert.usedCount}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default HubSpot;